import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'

class LandingContainer extends Component {
  render() {
    this.props.history.push('/signin')
    // return <div>
    //   <h2>Landing Container</h2>
    //   <p><Link to='/signin'>Sign In</Link></p>
    //   <p><Link to='/home'>Home</Link></p>
    // </div>

    return <BeatLoader loading={true} />
  }
}

export default LandingContainer


// WEBPACK FOOTER //
// ./src/containers/LandingContainer.js